import type { CanvaschoolApi } from "../api/client";

const MAX_PAGES = 20;

/** The canvas title is not part of the loaded canvas state, so it is found in
 * the class's canvas list. Null when it is not found or the list cannot be
 * read: the caller falls back to a generic name. */
export const findCanvasTitle = async (
  api: Pick<CanvaschoolApi, "listCanvases">,
  classId: string,
  canvasId: string,
): Promise<string | null> => {
  try {
    let cursor: string | undefined;
    for (let pages = 0; pages < MAX_PAGES; pages++) {
      const page = await api.listCanvases(classId, cursor);
      const found = page.items.find((item) => item.id === canvasId);
      if (found) {
        return found.title;
      }
      if (!page.nextCursor) {
        return null;
      }
      cursor = page.nextCursor;
    }
  } catch {
    // A missing title only changes the file name.
  }
  return null;
};
